import type { SxProps } from '@mui/material';

import { RangePicker } from '@cast/shared-date-ui';

import {
  INVENTORY_WORKLOADS_FILTER_PRESETS,
  INVENTORY_WORKLOADS_QUERY_PARAM_KEYS,
  useInventoryWorkloadsTimeRangeSelection,
} from '../_hooks/useInventoryWorkloadsTimeRangeSelection';

type Props = {
  sx?: SxProps;
};

export const InventoryWorkloadsRangePicker = (props: Props) => {
  const { initialState } = useInventoryWorkloadsTimeRangeSelection();

  return (
    <RangePicker
      sx={props.sx}
      queryParamKeys={INVENTORY_WORKLOADS_QUERY_PARAM_KEYS}
      initialPreset={initialState.preset}
      initialTimezone={initialState.timeZone}
      filterPresets={INVENTORY_WORKLOADS_FILTER_PRESETS}
      allowTimeInput
      maxNumberOfDays={31}
      triggerInputProps={{
        size: 'small',
        sx: { width: 250 },
      }}
    />
  );
};
